export default {
  brandName: "Basetao Sheet",
  navHome: "Inicio",
  navGuide: "Guía Spreadsheet",
  navCategories: "Categorías",
  navFaq: "FAQ",
  navShoppingGuide: "Guía de compra",
  articleNotFound: "Artículo no encontrado",
  tocTitle: "Índice de contenidos",
  backHome: "Volver al inicio",
  relatedTitle: "Recursos relacionados",
  authorName: "Equipo editorial de Basetao Sheet",
  authorRole: "Investigación de compras independiente",
  articleFaqTitle: "Preguntas frecuentes",
  ctaBasetao: "Basetao Spreadsheet",
  ctaBuyNow: "Comprar ahora",
  languageLabel: "Idioma",
  footerTagline:
    "Un centro de recursos independiente para la investigación de Basetao Spreadsheet, categorías de productos, guías y consejos prácticos de compra en China.",
  footerNavTitle: "Explorar",
  footerCategoriesTitle: "Categorías",
  footerLegalTitle: "Legal",
  footerPrivacy: "Privacidad",
  footerTerms: "Términos",
  footerDisclaimer: "Aviso legal",
  footerAbout: "Acerca de",
  footerContact: "Contacto",
  footerDisclaimerText:
    "Este es un sitio web informativo independiente. No estamos afiliados ni somos el sitio oficial de Basetao. Todas las marcas pertenecen a sus respectivos dueños. La disponibilidad, los precios y las tarifas de envío pueden cambiar en cualquier momento.",
  footerCopyright: "Todos los derechos reservados.",
  footerMadeWith: "Recurso independiente · Actualizado con regularidad",
};